module.exports = __webpack_public_path__ + "img/refreshing.8a9c1adc.svg";